import React from "react";
import "./MainBlog.scss";
import CardBlog from "./CardBlog";
import { Link } from "react-router-dom";

const TopBlogComponent = ({ firstFourItems, nextFourItems }) => {
  const renderFirstBlogItem = (item) => {
    if (!item) {
      return null; // Return nothing if the item is undefined or empty
    }

    return (
      <div className={"main-blog-page"} key={item.id}>
        <Link
          to={`/DetailBlog/${item.id}__${item.title.replace(/\s+/g, '-')}`}
          state={{ blogId: item.id }}
          className={"row-top"}
        >
          <div className="text-side">
            <h5>{item.title}</h5>
            <h6>{item.text}</h6>
            <div className="data-line display-none-RP">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="clock 1">
                  <path
                    id="Vector"
                    d="M9.99935 18.9584C5.05768 18.9584 1.04102 14.9417 1.04102 10C1.04102 5.05835 5.05768 1.04169 9.99935 1.04169C14.941 1.04169 18.9577 5.05835 18.9577 10C18.9577 14.9417 14.941 18.9584 9.99935 18.9584ZM9.99935 2.29169C5.74935 2.29169 2.29102 5.75002 2.29102 10C2.29102 14.25 5.74935 17.7084 9.99935 17.7084C14.2493 17.7084 17.7077 14.25 17.7077 10C17.7077 5.75002 14.2493 2.29169 9.99935 2.29169Z"
                    fill="#484848"
                  />
                  <path
                    id="Vector_2"
                    d="M13.0909 13.275C12.9826 13.275 12.8742 13.25 12.7742 13.1834L10.1909 11.6417C9.54922 11.2584 9.07422 10.4167 9.07422 9.67502V6.25836C9.07422 5.9167 9.35755 5.63336 9.69922 5.63336C10.0409 5.63336 10.3242 5.9167 10.3242 6.25836V9.67502C10.3242 9.97502 10.5742 10.4167 10.8326 10.5667L13.4159 12.1084C13.7159 12.2834 13.8076 12.6667 13.6326 12.9667C13.5076 13.1667 13.2992 13.275 13.0909 13.275Z"
                    fill="#484848"
                  />
                </g>
              </svg>
              <p>{item.date}</p>
            </div>
          </div>
          <div className="image-side">
            <img src={item.image} alt="" />
          </div>
        </Link>
      </div>
    );
  };

  return (
    <>
      {renderFirstBlogItem(firstFourItems[0])}
      <div className="row-middle">
        {firstFourItems.slice(1).map((item) => (
          <CardBlog key={item.id} blogData={item} />
        ))}
      </div>
      {renderFirstBlogItem(nextFourItems[0])}
      <div className="row-middle">
        {nextFourItems.slice(1).map((item) => (
          <CardBlog key={item.id} blogData={item} />
        ))}
      </div>
    </>
  );
};

export default TopBlogComponent;
